export default __webpack_public_path__ + "static/media/noun-airplane-1065274.213d7bc0.svg";